const fixedHolidays = [
    { monthDay: '01-01', name: 'Confraternização Universal', scopes: ['national'] },
    { monthDay: '04-21', name: 'Tiradentes', scopes: ['national', 'state'] },
    { monthDay: '05-01', name: 'Dia Mundial do Trabalho', scopes: ['national'] },
    { monthDay: '08-15', name: 'Assunção de Nossa Senhora', scopes: ['municipal'] },
    { monthDay: '09-07', name: 'Independência do Brasil', scopes: ['national'] },
    { monthDay: '10-12', name: 'Nossa Senhora Aparecida', scopes: ['national'] },
    { monthDay: '11-02', name: 'Finados', scopes: ['national'] },
    { monthDay: '11-15', name: 'Proclamação da República', scopes: ['national'] },
    { monthDay: '11-20', name: 'Dia Nacional de Zumbi e da Consciência Negra', scopes: ['national'] },
    { monthDay: '12-08', name: 'Imaculada Conceição', scopes: ['municipal'] },
    { monthDay: '12-25', name: 'Natal', scopes: ['national'] },
];
function assertYear(year) {
    if (!Number.isInteger(year) || year < 1900 || year > 2199) {
        throw new Error('Holiday year must be an integer between 1900 and 2199.');
    }
}
function formatLocalDate(year, month, day) {
    return `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}
function addUtcDays(localDate, days) {
    const [year, month, day] = localDate.split('-').map(Number);
    return new Date(Date.UTC(year, month - 1, day + days)).toISOString().slice(0, 10);
}
// Meeus/Jones/Butcher Gregorian computus. Easter anchors Belo Horizonte's movable holidays.
function easterSundayLocalDate(year) {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return formatLocalDate(year, month, day);
}
export function clinicHolidaysForYear(year) {
    assertYear(year);
    const easter = easterSundayLocalDate(year);
    return [
        ...fixedHolidays.map((holiday) => ({
            localDate: `${year}-${holiday.monthDay}`,
            name: holiday.name,
            scopes: holiday.scopes,
        })),
        {
            localDate: addUtcDays(easter, -2),
            name: 'Paixão de Cristo',
            scopes: ['municipal'],
        },
        {
            localDate: addUtcDays(easter, 60),
            name: 'Corpus Christi',
            scopes: ['municipal'],
        },
    ].sort((left, right) => left.localDate.localeCompare(right.localDate));
}
export function clinicHolidayForLocalDate(localDate) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(localDate);
    if (!match)
        return null;
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    if (year < 1900 || year > 2199)
        return null;
    const normalized = formatLocalDate(year, month, day);
    const parsed = new Date(`${normalized}T00:00:00.000Z`);
    if (parsed.getUTCFullYear() !== year ||
        parsed.getUTCMonth() !== month - 1 ||
        parsed.getUTCDate() !== day) {
        return null;
    }
    return clinicHolidaysForYear(year).find((holiday) => holiday.localDate === normalized) ?? null;
}
//# sourceMappingURL=holidays.js.map